var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAge(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 17.5,
    cy: 17.5,
    r: 16.5,
    stroke: "#424242",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.04 11.8L13.56 15.432C14.7227 15.464 15.6667 15.8427 16.392 16.568C17.1173 17.2933 17.48 18.2107 17.48 19.32C17.48 20.4613 17.1013 21.4 16.344 22.136C15.5867 22.8613 14.6107 23.224 13.416 23.224C12.2213 23.224 11.2453 22.8613 10.488 22.136C9.74133 21.4213 9.368 20.4827 9.368 19.32C9.368 18.4773 9.58667 17.7253 10.024 17.064L13.512 11.8H16.04ZM15.288 19.32C15.288 18.7867 15.112 18.3547 14.76 18.024C14.408 17.6827 13.96 17.512 13.416 17.512C12.872 17.512 12.424 17.6773 12.072 18.008C11.7307 18.3387 11.56 18.776 11.56 19.32C11.56 19.864 11.7307 20.3067 12.072 20.648C12.424 20.9787 12.872 21.144 13.416 21.144C13.96 21.144 14.408 20.9787 14.76 20.648C15.112 20.3067 15.288 19.864 15.288 19.32ZM23.2518 16.424H25.8918V18.36H23.2518V21H21.3158V18.36H18.6918V16.424H21.3158V13.8H23.2518V16.424Z",
    fill: "#424242"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAge);
export default __webpack_public_path__ + "static/media/age.f4f45a92f74c482c3a1bb437a995ddeb.svg";
export { ForwardRef as ReactComponent };